export default __webpack_public_path__ + "static/media/photo_gallery_3.38689ccb.png";